import { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Heading,
  useToast,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Avatar,
  AvatarGroup,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Input,
  Textarea,
  Select as SelectChakra,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  Popover,
  PopoverTrigger,
  PopoverFooter,
  ButtonGroup,
} from "@chakra-ui/react";
import axios from "axios";
import { Tooltip as TooltipChakra } from "@chakra-ui/react";
import Navbar from "../../../Components/Navbar";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { useDispatch } from "react-redux";
import { getUsers } from "../../../Redux/app/action";
import { useSelector } from "react-redux";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { RiDeleteBin2Line } from "react-icons/ri";
import CompanyMemberAssignment from "../../../Components/CompanyMemberAssignment";
import CompanyProjectForm from "../../../Components/CompanyProjectForm";
import CompanyStageForm from "../../../Components/CompanyStageForm";
import CompanySidebar from "../../../Components/CompanySidebar";

const BASE_URL = "https://develop-project-360.onrender.com";

export const getAllProjects = () => axios.get(`${BASE_URL}/getAllProjects`);
export const getStagesByProject = (projectId) =>
  axios.get(`${BASE_URL}/project/${projectId}`);

const InputStyle = {
  borderRadius: "md",
  borderWidth: "2px",
  borderColor: "gray.300",
  py: "2",
  px: "4",
  variant: "unstyled",
};

const BoxStyle = {
  position: "absolute",
  top: "-8px",
  left: "8px",
  pointerEvents: "none",
  color: "green",
  fontSize: "sm",
  bg: "white",
  px: "1",
};

const CompanyProjectDashboard = () => {
  const [projects, setProjects] = useState([]);
  //console.log("projects", projects);
  const [selectedProject, setSelectedProject] = useState(null);
  const [stages, setStages] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();
  //console.log("stages", stages);
  // const isMobile = useBreakpointValue({ base: true, md: false });

  ///////////////////////////////////////////////////
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);
  const users = useSelector((state) => state.AppReducer.users);
  const companyIdGlobal = useSelector((store) => store.authentication.users.id);
  const assignByGlobal = useSelector(
    (store) => store.authentication.users.company_name
  );
  let filteredCompanyEmployee = users.filter(
    (item) => item.companyId === companyIdGlobal
  );
  //console.log("filteredCompanyEmployee",filteredCompanyEmployee)
  const [selectedStage, setSelectedStage] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [files, setFiles] = useState([]);
  const [start_date, setstartDate] = useState("");
  const [end_date, setendDate] = useState("");
  const [priority, setPriority] = useState("");
  // const [selectedCc, setCc] = useState([]);
  const [selectedHourOption, setSelectedHourOption] = useState("");
  //console.log("selectedHourOption", selectedHourOption);
  const [selectedQuarterOption, setSelectedQuarterOption] = useState("");
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const todayDate = new Date().toISOString().split("T")[0];
  const {
    isOpen: isMainModalOpen,
    onOpen: onOpenMainModal,
    onClose: onCloseMainModal,
  } = useDisclosure();

  const {
    isOpen: isAssignModalOpen,
    onOpen: onOpenAssignModal,
    onClose: onCloseAssignModal,
  } = useDisclosure();

  const handleInputTitle = (e) => {
    const { name, value } = e.target;

    if (name === "title") {
      setTitle(value);
    }
  };

  const handleInputDescription = (e) => {
    const { name, value } = e.target;

    if (name === "description") {
      setDescription(value);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setDescription(description + "\n✤ ");
    }
  };

  const handleInputFiles = (e) => {
    const filesArray = Array.from(e.target.files);
    if (files.length > 4) {
      toast({
        position: "top",
        title: "Max 4 Files",
        description: "",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setFiles(filesArray);
  };

  const handleInputStart = (e) => {
    const { name, value } = e.target;

    if (name === "start_date") {
      setstartDate(value);
    }
  };

  const handleInputEnd = (e) => {
    const { name, value } = e.target;

    if (name === "end_date") {
      setendDate(value);
    }
  };

  const handleInputPriority = (selectedOption) => {
    // Use selectedOption to access the selected value
    const value = selectedOption ? selectedOption.value : null;
    setPriority(value);
  };

  const handleHourSelectChange = (value) => {
    setSelectedHourOption(value);
    setSelectedQuarterOption("");
  };

  const handleQuarterSelectChange = (value) => {
    setSelectedQuarterOption(value);
    setSelectedHourOption("");
  };

  const handleAddMultipleEmployeeTask = async () => {
    try {
      const formData = new FormData();
      //console.log("formDatabefore", formData);
      formData.append("title", title);
      formData.append("description", description);
      formData.append("start_date", start_date);
      formData.append("end_date", end_date);
      formData.append("priority", priority);
      formData.append("hourly", selectedHourOption);
      formData.append("quarterly", selectedQuarterOption);
      formData.append("assigned_by", assignByGlobal);
      formData.append("companyId", companyIdGlobal);
      // for (const ccEmail of selectedCc) {
      //   formData.append("cc[]", ccEmail);
      // }

      for (const department of selectedDepartments) {
        formData.append("department", department);
      }
      for (const employee of selectedEmployees) {
        formData.append("employee", employee);
      }

      for (const file of files) {
        formData.append("files", file);
      }

      formData.append("stageId", selectedStage?._id);
      formData.append("projectId", selectedProject?._id);

      //console.log("formDatafter", formData);

      const response = await axios.post(
        `https://develop-project-360.onrender.com/postmultipleById`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Response from server task:", response.data);
      toast({
        position: "top",
        title: "Task Added",
        description: "The task has been added.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      //console.error("Error adding task:", error);
      toast({
        position: "top",
        title: "Error",
        description: "An error occurred while adding the task.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const options = [
    { value: "All", label: "All" },
    {
      value: "Software Development",
      label: "Software Development",
    },
    {
      value: "Lead Generation",
      label: "Lead Generation",
    },
    {
      value: "Customer Support",
      label: "Customer Support",
    },
  ];

  const priorityOptions = [
    {
      value: "Low",
      label: "Low",
    },
    {
      value: "Medium",
      label: "Medium",
    },
    {
      value: "High",
      label: "High",
    },
  ];

  const filteredEmployeesss = filteredCompanyEmployee.filter((user) => {
    if (
      selectedDepartments.length === 0 ||
      selectedDepartments.includes("All")
    ) {
      return true;
    } else {
      return selectedDepartments.includes(user.department);
    }
  });

  const handleDepartmentChange = (selectedOptions) => {
    const selectedDepartmentValues = selectedOptions.map(
      (option) => option.value
    );

    if (selectedDepartmentValues.includes("All")) {
      setSelectedDepartments(
        options
          .filter((option) => option.value !== "All")
          .map((option) => option.value)
      );

      setSelectedEmployees(
        filteredEmployeesss
          .filter((employee) => employee.companyId === companyIdGlobal) // Filter by adminId
          .map((employee) => employee.sudo_name)
      );
    } else {
      setSelectedDepartments(selectedDepartmentValues);

      setSelectedEmployees((prevSelectedEmployees) =>
        prevSelectedEmployees.filter((employee) => {
          const employeeObj = filteredEmployeesss.find(
            (emp) =>
              emp.sudo_name === employee && emp.companyId === companyIdGlobal // Ensure adminId matches
          );
          return (
            employeeObj &&
            selectedDepartmentValues.includes(employeeObj.department)
          );
        })
      );
    }
  };

  const handleEmployeeChange = (selectedOptions) => {
    const selectedEmployeeValues = selectedOptions.map(
      (option) => option.value
    );

    if (selectedEmployeeValues.includes("All")) {
      setSelectedEmployees(
        filteredEmployeesss.map((employee) => employee.sudo_name)
      );
    } else {
      setSelectedEmployees(selectedEmployeeValues);
    }
  };

  ////////////////////////////////////////

  useEffect(() => {
    getAllProjects()
      .then((res) => {
        const allProjects = res.data.data || [];
        const filteredProjects = allProjects.filter(
          (project) => project.createdBy === companyIdGlobal
        );
        setProjects(filteredProjects);
        if (filteredProjects.length > 0) {
          setSelectedProject(filteredProjects[0]);
        }
      })
      .catch(() =>
        toast({ title: "Failed to load projects", status: "error" })
      );
  }, [toast, companyIdGlobal]);

  useEffect(() => {
    if (selectedProject?._id) {
      setLoading(true);
      getStagesByProject(selectedProject._id)
        .then((res) => {
          setStages(res.data.data || []);
        })
        .catch(() => toast({ title: "Failed to load stages", status: "error" }))
        .finally(() => setLoading(false));
    }
  }, [selectedProject, toast]);

  const handleProjectChange = (e) => {
    const projectId = e.target.value;
    const project = projects.find((p) => p._id === projectId);
    setSelectedProject(project);
  };

  const [hoveredIdEmployee, setHoveredIdEmployee] = useState(null);

  const handleHoverEmployee = (id) => {
    setHoveredIdEmployee(id);
  };

  const handleMouseLeaveEmployee = () => {
    setHoveredIdEmployee(null);
  };

  const handleStatusChange = async (stageId, newStatus, stageName) => {
    try {
      const response = await axios.put(`${BASE_URL}/stage/${stageId}/status`, {
        status: newStatus,
      });

      // Update the local stages state
      setStages((prevStages) =>
        prevStages.map((stage) =>
          stage._id === stageId ? { ...stage, status: newStatus } : stage
        )
      );

      toast({
        title: "Status updated",
        description: `${stageName} status changed to ${newStatus}`,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
        variant: "subtle",
      });
    } catch (error) {
      console.error("Error updating status:", error);
      toast({
        title: "Failed to update",
        description: "Something went wrong while changing the status.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handlePhaseDelete = async (stageId) => {
    try {
      await axios.delete(`${BASE_URL}/deleteProjectStage/${stageId}`);

      // Remove deleted stage from local state
      setStages((prevStages) =>
        prevStages.filter((stage) => stage._id !== stageId)
      );

      toast({
        title: "Stage Deleted",
        description: "The project stage has been successfully deleted.",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
        variant: "subtle",
      });
    } catch (error) {
      console.error("Error deleting stage:", error);
      toast({
        title: "Error",
        description: "Failed to delete the project stage.",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
        variant: "subtle",
      });
    }
  };

  return (
    <Flex>
      <CompanySidebar />
      <Box
        pl={{ base: "2", md: "10" }}
        pt={{ base: "10", md: "10" }}
        w={{ base: "100%", md: "80%" }}
      >
        <Navbar />
        <br />
        <br />
        <Box>
          <Flex justifyContent={"space-between"}>
            <Breadcrumb
              spacing="8px"
              mb={6}
              separator={<ChevronRightIcon color="gray.500" />}
            >
              <BreadcrumbItem>
                <BreadcrumbLink href="/company">Dashboard</BreadcrumbLink>
              </BreadcrumbItem>

              <BreadcrumbItem>
                <BreadcrumbLink href="#">Project Dashboard</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
            {/* <Button
              onClick={() => navigate("/admintask")}
              bgGradient="linear(to-r, green.300,  teal.100)"
              _hover={{
                bgGradient: "linear(to-r, green.100,  green.400)",
              }}
              size={"sm"}
            >
              See All Task
            </Button> */}
          </Flex>

          {/* Top Panel: Project Select + Forms */}
          <Flex direction="column" gap={6} width="100%">
            {/* Project Form (Full Width) */}
            <Box flex="1" width="100%">
              <CompanyProjectForm
                onProjectCreated={(newProject) => {
                  setProjects((prev) => [...prev, newProject]);
                  setSelectedProject(newProject);
                }}
              />
            </Box>

            {/* Member and Stage Forms */}
            {selectedProject && (
              <Flex
                direction={{ base: "column", md: "row" }}
                justify="space-between"
                gap={6}
                flexWrap="wrap"
                width="100%"
              >
                <Box minW={{ base: "80%", md: "33%" }}>
                  <CompanyStageForm
                    projectId={selectedProject._id}
                    onStageCreated={() => {
                      getStagesByProject(selectedProject._id).then((res) => {
                        setStages(res.data.data || []);
                      });
                    }}
                  />
                </Box>
                <Box flex="1" minW={{ base: "90%", md: "33%" }}>
                  <CompanyMemberAssignment
                    projectId={selectedProject._id}
                    companyId={selectedProject.companyId}
                  />
                </Box>
              </Flex>
            )}
          </Flex>

          {/* <KanbanBoard stages={stages} /> */}

          {/* Kanban Board Section */}
          <Flex
            direction={{ base: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ base: "flex-start", md: "center" }}
            gap={4}
            mb={4}
            mt={4}
          >
            {projects.length > 0 && (
              <SelectChakra
                placeholder="Select Project"
                onChange={handleProjectChange}
                value={selectedProject?._id || ""}
                width={{ base: "100%", md: "450px" }}
                maxH={10}
                overflowY={20}
              >
                {projects
                  .filter((project) => project.createdBy === companyIdGlobal)
                  .map((project) => (
                    <option key={project._id} value={project._id}>
                      {project.name}
                    </option>
                  ))}
              </SelectChakra>
            )}

            <Heading
              size="md"
              textAlign={{ base: "left", md: "right" }}
              width="100%"
            >
              {selectedProject?.priority || "No Priority"} -{" "}
              {selectedProject?.status || "No Status"}
            </Heading>
          </Flex>

          {loading ? (
            <Spinner size="lg" />
          ) : (
            <Box overflowX="auto">
              <Table variant="simple" colorScheme="teal" boxShadow={"md"}>
                <Thead>
                  <Tr boxShadow={"md"}>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Phases
                    </Th>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Description
                    </Th>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Assigned To
                    </Th>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Tasks Count
                    </Th>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Created At
                    </Th>
                    <Th style={{ textAlign: "center" }} boxShadow={"md"}>
                      Status
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {stages.map((stage, index) => (
                    <Tr key={stage._id}>
                      <Td style={{ textAlign: "center" }}>
                        <Button size={"xs"} fontWeight={"bold"}>
                          {stage.name}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Button size={"xs"} fontWeight={"bold"}>
                          {stage.description || "N/A"}
                        </Button>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Flex justifyContent="center" alignItems="center">
                          <TooltipChakra
                            label={`Assigned To: ${selectedProject.members
                              .map((m) => m.sudo_name)
                              .join(", ")}`}
                            isOpen={hoveredIdEmployee === stage._id}
                            placement="bottom"
                            color="green.500"
                          >
                            <Flex
                              onMouseEnter={() =>
                                handleHoverEmployee(stage._id)
                              }
                              onMouseLeave={handleMouseLeaveEmployee}
                            >
                              <AvatarGroup size="xs" max={4}>
                                {selectedProject.members.map((member, idx) => (
                                  <Avatar
                                    key={idx}
                                    name={member.sudo_name}
                                    src={`https://develop-project-360.onrender.com/${member.path}`}
                                  />
                                ))}
                              </AvatarGroup>
                              <Button
                                size="xs"
                                fontWeight="bold"
                                onMouseEnter={() =>
                                  handleHoverEmployee(stage._id)
                                }
                                onMouseLeave={handleMouseLeaveEmployee}
                              >
                                {selectedProject.members[0]?.sudo_name || "N/A"}
                              </Button>
                              {selectedProject.members.length > 1 && (
                                <Button
                                  size="xs"
                                  rounded="full"
                                  fontWeight="bold"
                                  bg="gray.300"
                                  color="red"
                                  fontSize={10}
                                  ml={2}
                                  onMouseEnter={() =>
                                    handleHoverEmployee(stage._id)
                                  }
                                  onMouseLeave={handleMouseLeaveEmployee}
                                >
                                  +{selectedProject.members.length - 1}
                                </Button>
                              )}
                            </Flex>
                          </TooltipChakra>
                        </Flex>
                      </Td>
                      {/* <Td style={{ textAlign: "center" }}>
                        <Button size={"xs"} fontWeight={"bold"}>
                          {stage.tasks?.length || 0}
                        </Button>
                      </Td> */}
                      <Td style={{ textAlign: "center" }}>
                        <Button
                          size="xs"
                          fontWeight="bold"
                          onClick={() => {
                            setSelectedStage(stage);
                            onOpenMainModal();
                          }}
                        >
                          {stage.tasks?.length || 0}
                        </Button>
                      </Td>

                      <Td style={{ textAlign: "center" }}>
                        <Button size={"xs"} fontWeight={"bold"}>
                          {new Date(stage.createdAt).toLocaleDateString()}
                        </Button>
                      </Td>

                      <Td style={{ textAlign: "center" }}>
                        <Popover placement="bottom">
                          <PopoverTrigger>
                            <Button
                              size={"xs"}
                              fontWeight={"bold"}
                              color={
                                stage.status === "Cancelled"
                                  ? "red"
                                  : stage.status === "Completed"
                                  ? "green"
                                  : stage.status === "On Hold"
                                  ? "orange"
                                  : "blue"
                              }
                            >
                              {stage.status}
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent width="auto">
                            <PopoverArrow />
                            <PopoverCloseButton />
                            <PopoverBody p={5}>
                              {[
                                "Pending",
                                "Completed",
                                "On Hold",
                                "Cancelled",
                              ].map((statusOption) => (
                                <Button
                                  key={statusOption}
                                  size="xs"
                                  colorScheme={
                                    statusOption === "Cancelled"
                                      ? "red"
                                      : statusOption === "Completed"
                                      ? "green"
                                      : statusOption === "On Hold"
                                      ? "orange"
                                      : "blue"
                                  }
                                  m={1}
                                  onClick={() =>
                                    handleStatusChange(
                                      stage._id,
                                      statusOption,
                                      stage.name
                                    )
                                  }
                                >
                                  {statusOption}
                                </Button>
                              ))}
                            </PopoverBody>
                          </PopoverContent>
                        </Popover>
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        <Flex justifyContent={"center"} gap={2}>
                          <Popover>
                            <PopoverTrigger>
                              <Button size={"xs"} color="red">
                                <RiDeleteBin2Line />
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent>
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverBody>
                                Are you sure you want to delete?
                              </PopoverBody>
                              <PopoverFooter
                                display="flex"
                                justifyContent="flex-end"
                                gap={2}
                              >
                                <ButtonGroup size="xs"></ButtonGroup>
                                <ButtonGroup size="xs">
                                  <Button
                                    color="green"
                                    _hover={{
                                      color: "white",
                                      bgColor: "green",
                                    }}
                                    onClick={() => handlePhaseDelete(stage._id)}
                                    fontWeight={"bold"}
                                  >
                                    Yes
                                  </Button>
                                </ButtonGroup>
                              </PopoverFooter>
                            </PopoverContent>
                          </Popover>
                        </Flex>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
              <Modal
                isOpen={isMainModalOpen}
                onClose={onCloseMainModal}
                isCentered
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader></ModalHeader>
                  <ModalCloseButton />
                  <ModalBody isCentered>
                    <Flex justifyContent={"space-evenly"}>
                      <Button
                        onClick={() => {
                          onCloseMainModal();
                          onOpenAssignModal();
                        }}
                        bgGradient="linear(to-r, green.300,  teal.100)"
                        _hover={{
                          bgGradient: "linear(to-r, green.100,  green.400)",
                        }}
                      >
                        Assign Task
                      </Button>
                      <Button
                        onClick={() =>
                          navigate("/viewcompanytask", {
                            state: {
                              selectedProject,
                              stage: selectedStage,
                            },
                          })
                        }
                        bgGradient="linear(to-r, green.300,  teal.100)"
                        _hover={{
                          bgGradient: "linear(to-r, green.100,  green.400)",
                        }}
                      >
                        View Assigned Task
                      </Button>
                    </Flex>
                  </ModalBody>
                  <ModalFooter></ModalFooter>
                </ModalContent>
              </Modal>
            </Box>
          )}
          <Modal
            isOpen={isAssignModalOpen}
            onClose={onCloseAssignModal}
            size="2xl"
          >
            <ModalOverlay />
            <form
              onSubmit={handleAddMultipleEmployeeTask}
              encType="multipart/form-data"
            >
              <ModalContent>
                <ModalHeader>Assign Task</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Box position="relative">
                    <Input
                      {...InputStyle}
                      required
                      type="text"
                      id="title"
                      name="title"
                      value={title}
                      onChange={handleInputTitle}
                    />
                    <Box {...BoxStyle}>Title*</Box>
                  </Box>
                  <br />
                  <Box position="relative">
                    <Textarea
                      {...InputStyle}
                      required
                      type="text"
                      id="description"
                      name="description"
                      value={description}
                      onChange={handleInputDescription}
                      onKeyPress={handleKeyPress}
                    />
                    <Box {...BoxStyle}>Description*</Box>
                  </Box>
                  <br />

                  {/* <Flex justifyContent="space-between">
                        <Box position="relative" mb={5} width="45%">
                          <SelectChakra
                            placeholder="Select Assigned By"
                            value={assignedBy}
                            onChange={(e) => setassignedBy(e.target.value)}
                          >
                            <option value="ED SD Manager">Manager</option>
                          </SelectChakra>
                          <Box {...BoxStyle}>Assigned By</Box>
                        </Box>
                        <Box position="relative" mb={5} width="45%">
                          <Select
                            placeholder="Select CC"
                            isMulti
                            name="cc"
                            id="cc"
                            onChange={handleCcChange}
                            value={selectedCc.map((email) => ({
                              value: email,
                              label: email,
                            }))}
                            options={ccOptions} 
                          />
                          <Box {...BoxStyle}>Cc</Box>
                        </Box>
                      </Flex> */}

                  <Box position="relative">
                    <Input
                      {...InputStyle}
                      type="file"
                      id="file"
                      name="file"
                      onChange={handleInputFiles}
                      multiple
                    />
                    <Box {...BoxStyle}>Attach Files</Box>
                    {files.length === 0 && (
                      <Box fontSize="xs" mt="2" color={"red"}>
                        Max 4 files can be selected.
                      </Box>
                    )}
                    {files && files.length > 0 && files.length <= 4 && (
                      <Box fontSize="xs" mt="2">
                        {files.length} Files selected.
                      </Box>
                    )}
                  </Box>
                  <br />

                  <Box position="relative" mb={5}>
                    <Select
                      placeholder=""
                      required
                      name="priority"
                      id="priority"
                      onChange={handleInputPriority}
                      value={priorityOptions.find(
                        (option) => option.value === priority
                      )}
                      options={priorityOptions}
                    />

                    <Box {...BoxStyle}>Priority*</Box>
                  </Box>

                  <Box position="relative" mb={5}>
                    <Select
                      placeholder=""
                      required
                      isMulti
                      name="department"
                      id="department"
                      onChange={handleDepartmentChange}
                      value={selectedDepartments.map((department) => ({
                        value: department,
                        label: department,
                      }))}
                      options={options}
                    />
                    <Box {...BoxStyle}>Select Department*</Box>
                  </Box>

                  <Box position="relative" mb={5}>
                    <Select
                      placeholder=""
                      required
                      isMulti
                      name="employee"
                      id="employee"
                      onChange={handleEmployeeChange}
                      value={selectedEmployees.map((employee) => ({
                        value: employee,
                        label: employee,
                      }))}
                      options={[
                        { value: "All", label: "All" },
                        ...filteredEmployeesss.map((employee) => ({
                          value: employee.sudo_name,
                          label: employee.sudo_name,
                        })),
                      ]}
                    />
                    <Box {...BoxStyle}>Select Employee*</Box>
                  </Box>

                  <Box position="relative">
                    <Input
                      {...InputStyle}
                      type="date"
                      id="start_date"
                      name="start_date"
                      value={start_date}
                      onChange={handleInputStart}
                      min={todayDate}
                    />
                    <Box {...BoxStyle}>Start Date*</Box>
                  </Box>

                  <br />

                  <Flex justifyContent="space-between">
                    <Box position="relative" mb={5} width="45%">
                      <SelectChakra
                        placeholder="Select Hours"
                        value={selectedHourOption}
                        onChange={(e) => handleHourSelectChange(e.target.value)}
                        isDisabled={
                          selectedQuarterOption !== "" || end_date !== ""
                        }
                      >
                        <option value="30 Min">30 Min</option>
                        <option value="1 Hour">1 Hour</option>
                        <option value="2 Hour">2 Hour</option>
                        <option value="3 Hour">3 Hour</option>
                        <option value="4 Hour">4 Hour</option>
                        <option value="5 Hour">5 Hour</option>
                      </SelectChakra>

                      <Box {...BoxStyle}>Select Hours</Box>
                    </Box>
                    <Box position="relative" mb={5} width="45%">
                      <SelectChakra
                        placeholder="Select Quarters"
                        value={selectedQuarterOption}
                        onChange={(e) =>
                          handleQuarterSelectChange(e.target.value)
                        }
                        isDisabled={
                          selectedHourOption !== "" || end_date !== ""
                        }
                      >
                        <option value="1st">1st quarter</option>
                        <option value="2nd">2nd quarter</option>
                        <option value="3rd">3rd quarter</option>
                        <option value="4th">4th quarter</option>
                      </SelectChakra>

                      <Box {...BoxStyle}>Select Quarters</Box>
                    </Box>
                  </Flex>

                  <Box position="relative">
                    <Input
                      {...InputStyle}
                      type="date"
                      id="end_date"
                      name="end_date"
                      value={end_date}
                      onChange={handleInputEnd}
                      isDisabled={selectedHourOption || selectedQuarterOption}
                      min={start_date}
                    />
                    <Box {...BoxStyle}>End Date</Box>
                  </Box>
                </ModalBody>
                <ModalFooter>
                  <Button
                    type="submit"
                    bgGradient="linear(to-r, teal.300,  teal.100)"
                    _hover={{
                      bgGradient: "linear(to-r, teal.100,  teal.400)",
                    }}
                  >
                    Assign Task
                  </Button>
                </ModalFooter>
              </ModalContent>
            </form>
          </Modal>
        </Box>
      </Box>
    </Flex>
  );
};

export default CompanyProjectDashboard;
